// extracted by mini-css-extract-plugin
export var description = "list-module--description--9d960";
export var heading = "list-module--heading--7a22a";
export var image = "list-module--image--4b59d";